module.exports = __webpack_public_path__ + "img/b7cf957.jpg";